// Petición autenticada con el token de empresa (`empresa-token`).
import { ApiError, NETWORK_ERROR_MESSAGE } from './staffApi';

export const empresaFetch = async (path, { method = 'GET', body } = {}) => {
  const headers = { Authorization: `Bearer ${localStorage.getItem('empresa-token')}` };
  if (body !== undefined) headers['Content-Type'] = 'application/json';

  let response;
  try {
    response = await fetch(path, {
      method,
      headers,
      body: body !== undefined ? JSON.stringify(body) : undefined,
    });
  } catch (e) {
    throw new ApiError(NETWORK_ERROR_MESSAGE);
  }

  let data = null;
  try {
    data = await response.json();
  } catch (e) {
    data = null;
  }

  if (!response.ok || !data || data.success === false) {
    throw new ApiError(
      (data && data.error) || 'Ocurrió un error. Inténtalo de nuevo.',
      { status: response.status, code: data && data.code, data }
    );
  }
  return data;
};
